import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import GlobalChart from "./Components/GlobalChart/GlobalChart";
import SalesChart from "./Components/SalesChart/SalesChart";
import SalesStatesChart from "./Components/SalesStatesChart/SalesStatesChart";
import PieSalesChart from "./Components/SalesStatesChart/PieSalesChart";
import StaffCommisionChart from "./Components/StaffCommisionChart/StaffCommisionChart";
import StaffPieChart from "./Components/StaffCommisionChart/StaffPieChart";
import { getEvents } from "../../../actions/adminDashboardActions";
import { getStaffs } from "../../../actions/staffActions";
import HomepageToggle from "../../../components/HomepageToggle/HomepageToggle";
import useFeatureRedirect from "../../../hooks/useFeatureRedirect";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import { hasMetricsReporting } from "../../../utils/featureAccessHelpers";
import "./Components/DashboardCss/dashboardAdmin.scss";
import "../../../components/HomepageToggle/homepageToggle.scss";

const Dashboard = (props) => {
  const [events, setEvents] = useState([]);
  const [staffs, setStaffs] = useState([]);

  useEffect(() => {
    const { getEvents, getStaffs } = props;
    getEvents({
      data: {},
      onSuccess: function (data) {
        setEvents([{ value: "", label: "All Events" }, ...data.events]);
      },
      onError: function (error) {
        console.log("error", error);
      },
    });

    getStaffs({
      data: {
        pageSize: 10000,
        pageNumber: 1,
      },
      onSuccess: function (response) {
        const staffList = response.entity.map((staff) => {
          return {
            label: staff.first_name + " " + staff.last_name,
            value: staff.id,
          };
        });
        setStaffs([{ value: "", label: "All Staffs" }, ...staffList]);
      },
      onError: function (error) {
        console.log("error", error);
      },
    });
  }, []);

  return (
    <>
      <div className="admin-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-title">
            <h1>Analytics Dashboard</h1>
            <p>Track your bookings, revenue, and team performance</p>
          </div>
          <HomepageToggle />
        </div>

        <div className="dashboard-section">
          <GlobalChart events={events} />
        </div>

        <div className="dashboard-section">
          <SalesChart />
        </div>

        <div className="dashboard-section">
          <div className="section-title">Sales & Availability</div>
          <div className="dashboard-grid grid-2-1">
            <SalesStatesChart events={events} />
            <PieSalesChart events={events} />
          </div>
        </div>

        <div className="dashboard-section">
          <div className="section-title">Staff Performance</div>
          <div className="dashboard-grid grid-1-2">
            <StaffPieChart staffs={staffs} />
            <StaffCommisionChart staffs={staffs} />
          </div>
        </div>
      </div>
    </>
  );
};

const ConnectedDashboard = connect(null, { getEvents, getStaffs })(Dashboard);

const DashboardGuarded = (props) => {
  const { features, loaded } = useSelector((state) => state.featureAccess);

  useFeatureRedirect(
    FEATURE_IDS.METRICS_REPORTING,
    "/admin/scheduled-events"
  );

  if (!loaded || !hasMetricsReporting(features)) {
    return <Loader isShowLoader />;
  }

  return <ConnectedDashboard {...props} />;
};

export default DashboardGuarded;
